import React from 'react';
import classNames from 'classnames';

import { Link } from 'react-router-dom';

import Label from './Label';

export const LinkLabel = ({
  className,
  children,
  to,
  bold = false,
  italic = false,
  size = 'md',
  color = 'brand',
  hoverColor = 'highlighted',
  activeColor = 'faded-brand',
  ...rest
}) => (
  <Link to={to}>
    <Label
      className={classNames(`cursor-pointer hover:text-${hoverColor} active:text-${activeColor}`, className)}
      bold={bold}
      italic={italic}
      size={size}
      color={color}
      {...rest}
    >
      { children }
    </Label>
  </Link>
)

export default LinkLabel;
